import "./Card.css";
import { cn } from "@netlify/ui";
// todo(calebbarnes): theme not working in css modules
// import styles from "./Card.module.css";

export type CardProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  variant?: "hero" | "bottomless" | undefined;
};

export const Card = ({ variant, children, className }: CardProps) => (
  <section
    className={cn(
      // todo(calebbarnes): theme not working in css modules
      // styles["card"],
      // typeof variant === "string" && styles[`card-${variant}`],
      "card",
      variant && `card-${variant}`,
      className,
    )}
  >
    {children}
  </section>
);
